import { render } from "./reworked_checkout_basic.vue?vue&type=template&id=2514aed8"
import script from "./reworked_checkout_basic.vue?vue&type=script&lang=js"
export * from "./reworked_checkout_basic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__